import { types } from 'mobx-state-tree';
import { ExtraFieldTypeType } from '../../types/ExtraFieldType';

const OrderExtraField = types.model('OrderExtraField', {
  id: types.number,
  name: types.string,
  type: ExtraFieldTypeType,
  value: types.maybeNull(
    types.union(
      types.string,
      types.number,
      types.array(types.string),
      types.array(types.number),
      types.boolean
    )
  ),
});

export default OrderExtraField;
